import { BaseRequestsService } from '@/services/base-requests-service';

class RegisterRequests extends BaseRequestsService {

  register(options) {
    return this.http.post('v2/users/signup', options);
  }

  confirm(options) {
    return this.http.post('v2/users/signup/confirm', options);
  }

}

const registerRequests = new RegisterRequests();
export { registerRequests as RegisterRequests };
